<app-admin-list 
    buttonText="Agregar extra"
    [buttonUrl]="buttonUrl"
    description="Selecciona uno de tus extras para acceder a sus detalles."
    icon="takeout_dining"
    [list]="extras | fromExtrasToListItem : params"
    noDataText="Todavía no tienes extras agregados."
>
</app-admin-list>
